goog.provide("shadow.js.shim.module$$mui$material$Step");
goog.provide("module$shadow_js_shim_module$$mui$material$Step");
shadow.js.shim.module$$mui$material$Step = shadow.js.nativeProvides["@mui/material/Step"] = shadow$bridge("@mui/material/Step");
module$shadow_js_shim_module$$mui$material$Step.default = shadow.js.shim.module$$mui$material$Step;
